// src/pages/Home/components/Navbar3/components/NavbarMenuButton.jsx

import React from "react";

import {
  Divide as Hamburger,
} from "hamburger-react";

export default function NavbarMenuButton({
  menuOpen,
  onToggle,
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={menuOpen}
      aria-controls="main-navigation-panel"
      aria-label={
        menuOpen
          ? "Fermer le menu"
          : "Ouvrir le menu"
      }
      className="
        flex h-[68px] w-[68px]
        shrink-0 flex-col
        items-center justify-center
        bg-blueprimary
        transition-colors
        hover:bg-blueprimarylight
        focus-visible:outline-none
        focus-visible:ring-4
        focus-visible:ring-inset
        focus-visible:ring-white/50
        md:h-[100px]
        md:w-[100px]
      "
    >
      <div className="pointer-events-none -my-1">
        <Hamburger
          toggled={menuOpen}
          toggle={() => {}}
          size={27}
          direction="right"
          duration={0.4}
          color="white"
          rounded
        />
      </div>

      <span
        className="
          text-[10px]
          font-semibold
          uppercase
          tracking-wide
          text-white
          md:mt-1
          md:text-sm
        "
      >
        {menuOpen
          ? "Fermer"
          : "Menu"}
      </span>
    </button>
  );
}